import React from 'react'

const AdminLandingBlock = () => {
  return (
    <div className="w-[350px] h-[256px] bg-gradient-to-r from-[#F2F2F2] to-[rgba(242, 242, 242, 0.00)] rounded-lg "></div>
  )
}

export default AdminLandingBlock